import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../css/components/ProductDetails.css';
import ResponseMsg from '../general/ResponseMsg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';


const ProDetails = ({isAdmin}) => {
    const [response, setResponse] = useState(null);
    const location = useLocation();
    const [showUpload, setShowUpload] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const product = location.state?.product;
    const [imagePreview, setImagePreview] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [error, setError] = useState('');
    const [selectedImage, setSelectedImage] = useState('');
    const navigate = useNavigate();

    if (!product) {
        return <div>No product details available</div>;
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    };


    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);

        if (files.length > 5) {
            setError('You can upload a maximum of 5 images.');
            return;
        }

        setError('');
        const imageUrls = files.map(file => URL.createObjectURL(file));
        setImagePreview(imageUrls);
        setSelectedFiles(files);
    };


    const handleSubmit = async () => {
        const formData = new FormData();

        selectedFiles.forEach(file => {
            formData.append('images', file);
        });

        try {
            const response = await fetch(`https://api.kcmstore.in/store/add-product-image/${product.id}`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to upload images');
            }

            const data = await response.json();
            setResponse('Images Uploaded successfully!');
            setShowUpload(false);
            setTimeout(() => {
                setResponse('');
                setImagePreview([]);
                setSelectedFiles([]);
                navigate(`/`);
            }, 2000);

        } catch (error) {
            console.error('Error uploading images:', error);
        }
    };


    const productImages = product.image ? product.image.split(',') : [];
    const defaultImage = productImages[0];

    if (!selectedImage && defaultImage) {
        setSelectedImage(defaultImage);
    }

    const handleImageClick = (image) => {
        setSelectedImage(image);
    };


    const handleDeleteImage = async () => {
        try {
            // Make an API call to delete the selected image
            const response = await fetch(`https://api.kcmstore.in/store/delete-product-image/${product.id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ image: selectedImage }), // Pass the selected image to delete
            });
    
            if (response.ok) {
                setResponse('Image deleted successfully!');
                setShowDelete(false);
                setTimeout(() => {
                    setResponse('');
                    setSelectedImage(null);
                    navigate(`/`);
                }, 2000);    
            } else {
                setResponse('Failed to delete image');
                setShowDelete(false);
                setTimeout(() => {
                    setResponse('');
                    setSelectedImage(null);
                }, 2000);
            }
        } catch (error) {
            console.error('Error deleting image:', error);
            setResponse('Error deleting image');
        }
    };

    
    return (
        <>
            <section className='py-5 bg-light px-3'>

                <div className='d-flex'>
                    <p className='sec-heading'>Product Details</p>
                    <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Explore</span>
                </div>

                <div className="px-3 bg-white py-4 rounded-4">

                    <div className="row">

                        <div className="col-lg-6 my-2">
                            <div className='product-img-outer'>
                                <div className='product-img-stock'>{product.stock == '0' ? 'Out of Stock !' : ''}</div>
                                <div className='position-relative'>
                                    <img
                                        src={`https://api.kcmstore.in/sUploads/${selectedImage}`}
                                        alt={product.name}
                                        className="product-img"
                                    />
                                    {isAdmin &&
                                    <span className='delete-btn' onClick={() => setShowDelete(true)}>Delete this Image <i class="fa-solid fa-xmark"></i></span>
                                }
                                </div>

                                <Swiper spaceBetween={20} slidesPerView={5} modules={[Autoplay, Navigation]} loop={true}
                                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 3,
                                            spaceBetween: 40,
                                        },
                                        576: {
                                            slidesPerView: 4,
                                            spaceBetween: 20,
                                        },

                                        768: {
                                            slidesPerView: 5,
                                            spaceBetween: 20,
                                        },
                                        992: {
                                            slidesPerView: 3,
                                            spaceBetween: 20,
                                        },
                                        1298: {
                                            slidesPerView: 5,
                                            spaceBetween: 20,
                                        }
                                    }}>

{isAdmin && 
<SwiperSlide>
<div className='tab-image my-3 border-0 align-content-center' onClick={() => setShowUpload(true)}>
    <span className='cursor-pointer'><i class="fa-solid fa-plus bg-dark text-white px-2 py-2 fs-5 rounded-circle"></i></span>
</div>
</SwiperSlide>
}

                                    {product.image && product.image.split(',').map((image, index) => (
                                        <SwiperSlide key={index}>
                                            <img
                                                src={`https://api.kcmstore.in/sUploads/${image}`}
                                                alt={`Product image ${index + 1}`}
                                                className="tab-image my-3"
                                                onClick={() => handleImageClick(image)}
                                            />
                                        </SwiperSlide>
                                    ))}



                                </Swiper>

                            </div>
                        </div>

                        <div className="col-lg-6 align-content-center my-2">
                          <p className='my-0'><span className='para-text bg-orange text-light fw-semibold rounded-pill px-3 py-1'>{product.brand || ''}</span></p>
                            <p className='sec-heading mb-0'>{product.name}</p>
                            <span className='fw-bold text-muted'>{product.unit}</span>

                            <p className='fs-5 fw-semibold mt-3'>Product Price: <br />
                                <span className='fs-4 featured-price'>₹ {product.sell_price}{product.discount_amount > 0 && (
                                    <span className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                                        {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'}  Off
                                    </span>
                                )}</span></p>
                                
                            <p className='fw-semibold text-muted'>Category: {product.category || '-'}</p>
                        </div>

                    </div>
                    {/* row ends */}


                    <div className='row mt-4'>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Product Details</div>
                        <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded preserve-lines'>Manufactured On: {formatDate(product.mfg) || 'NA'}<br />
                            Expire On: {formatDate(product.exp) || 'NA'}<br />
                            Brand: {product.brand || '-'}<br />
                            {/* Purchase Price: ₹ {product.purchase_price || 'NA'}<br /> */}
                            MRP: ₹ {product.org_price || 'NA'}<br />
                            Tax Type: {product.tax_type || 'NA'}<br />
                            Tax Amount: {(product.tax_amount == 'None' ? 'None' : `${product.tax_amount}%`) || 'NA'}<br /></p></div>


                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Composition</div>
                        {/* <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.description || 'NA' }} /></div> */}
                        <div className='col-lg-8 col-md-8 my-1'><pre className='bg-light px-3 py-3 rounded preserve-lines'>{product.composition || 'NA'}</pre></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Description</div>
                        {/* <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.description || 'NA' }} /></div> */}
                        <div className='col-lg-8 col-md-8 my-1'><pre className='bg-light px-3 py-3 rounded preserve-lines'>{product.description || 'NA'}</pre></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Prescription</div>
                        {/* <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.prescription || 'NA' }} /></div> */}
                        <div className='col-lg-8 col-md-8 my-1'><pre className='bg-light px-3 py-3 rounded preserve-lines'>{product.prescription || 'NA'}</pre></div>

                        <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Side Effects</div>
                        <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded preserve-lines'>Most side effects do not
                            require any medical attention and disappear as your body adjusts to the medicine. Consult your doctor if
                            they persist or if you are worried about them</p></div>


                    </div>
                    {/* row ends */}


                </div>
            </section>

            {response && <ResponseMsg message={response} />}


            {showUpload && (
                <section className='delete-dialog px-3'>
                    <div className='bg-white col-lg-6 col-md-8 mx-auto px-3 py-4 rounded-4'>
                        <p className='sec-heading fs-5'>Upload Images</p>

                        <div className='py-3'>
                            <input
                                type="file"
                                className='bg-light px-2 py-2 col-md-8 col-12'
                                accept="image/*"
                                multiple
                                onChange={handleImageChange}
                            /><br />
                            {error && <p className="text-danger para-text fw-semibold">{error}</p>}            </div>
                        <div className="preview-images my-4">
                            {imagePreview.map((image, index) => (
                                <img key={index} src={image} className='col-lg-2 col-md-3 col-3' alt={`preview ${index}`} style={{ margin: '5px' }} />
                            ))}
                        </div>

                        <button className='danger-btn' onClick={() => setShowUpload(false)}>Cancel</button>&nbsp;&nbsp;
                        <button className='success-btn' onClick={handleSubmit}>Submit</button>
                    </div>
                </section>
            )}


            {showDelete && (
        <>
        <section className='delete-dialog px-3'>
          <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-4 rounded-4'>
            <p className='featured-category'>Do you want to delete this Image?</p>
            <img
                                        src={`https://api.kcmstore.in/sUploads/${selectedImage}`}
                                        alt={product.name}
                                        className="tab-image my-4"
                                    /><br />
            <button className='success-btn' onClick={() => handleDeleteImage()}>Yes</button>&nbsp;&nbsp;
            <button className='danger-btn' onClick={() => setShowDelete(false)}>No</button>
          </div>
        </section>
      </>
            )}


        </>
    );
};

export default ProDetails;
